var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "149.1 170.4 781.7 781.7",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 615,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id123_sdhlajw49"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 561.21,
    r: 390.86,
    style: {
      fill: "rgb(217, 217, 217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id124_sdhlajw49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.42 485.59L306.42 720.96 773.58 720.96 773.58 485.59 540 638.18 306.42 485.59z",
    style: {
      fill: "rgb(1, 1, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id125_sdhlajw49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.42 388.48L306.42 430.55 540 582.69 773.58 430.55 773.58 388.48 306.42 388.48z",
    style: {
      fill: "rgb(1, 1, 1)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.44066f5dcb620342494390ca4de4326f.svg";
export { ForwardRef as ReactComponent };